module.exports = __webpack_public_path__ + "static/media/DSC09422.71729673.jpg";